import React from 'react';
import {Grid, Segment, Button, Icon} from 'semantic-ui-react';

export default (props) => {
    return <Grid>
        <Grid.Row>
            <Grid.Column>
                <Segment textAlign='left' basic clearing>
                    <Button floated="left" style={{borderRadius: 0}} type="back" negative onClick={props.handleButtonClick}>
                        <Icon name='arrow left'/>
                        {props.content}
                    </Button>
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>
}


// WEBPACK FOOTER //
// ./src/components/backButton/BackButtonContainer.jsx